module.exports = __webpack_public_path__ + "img/先锐模具.3b9d211e.jpg";